import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/i18n/LanguageContext";
import { acceptAnalytics, refuseAnalytics, getConsentChoice } from "@/lib/analytics";

const COPY = {
    fr: {
        aria: "Consentement aux cookies",
        text: "Nous mesurons l'audience du site avec Google Analytics, uniquement avec votre accord. Aucun cookie analytique n'est déposé sans votre consentement — votre choix est conservé 6 mois.",
        more: "En savoir plus",
        accept: "Tout accepter",
        refuse: "Tout refuser",
    },
    en: {
        aria: "Cookie consent",
        text: "We measure site audience with Google Analytics, only with your consent. No analytics cookie is set without your agreement — your choice is kept for 6 months.",
        more: "Learn more",
        accept: "Accept all",
        refuse: "Reject all",
    },
};

export default function ConsentBanner() {
    const { lang, prefix } = useLang();
    const [visible, setVisible] = useState(() => getConsentChoice() === null);

    useEffect(() => {
        // Évite que le bandeau ne recouvre les CTA en bas de page (ex. bouton d'envoi du formulaire)
        document.body.style.paddingBottom = visible ? "150px" : "";
        return () => { document.body.style.paddingBottom = ""; };
    }, [visible]);

    if (!visible || !process.env.REACT_APP_GA_MEASUREMENT_ID) return null;
    const c = COPY[lang] || COPY.fr;
    const choose = (fn) => () => { fn(); setVisible(false); };

    return (
        <div data-testid="consent-banner" role="dialog" aria-label={c.aria} className="fixed inset-x-0 bottom-0 z-[90] px-4 pb-4">
            <div className="mx-auto max-w-3xl bg-weyb-ink text-white border border-white/10 rounded-sm shadow-[0_24px_64px_rgba(10,15,22,0.45)] p-5 md:p-6 flex flex-col md:flex-row md:items-center gap-4">
                <p className="text-sm text-white/70 leading-relaxed flex-1">
                    {c.text}{" "}
                    <Link to={`${prefix}/politique-de-confidentialite`} data-testid="consent-more-link" className="underline underline-offset-2 text-white hover:text-weyb-yellow transition-colors">
                        {c.more}
                    </Link>
                </p>
                <div className="flex gap-3 shrink-0">
                    <button
                        data-testid="consent-refuse"
                        onClick={choose(refuseAnalytics)}
                        className="px-5 py-2.5 text-sm font-medium border border-white/25 text-white hover:border-weyb-yellow hover:text-weyb-yellow rounded-sm transition-colors"
                    >
                        {c.refuse}
                    </button>
                    <button
                        data-testid="consent-accept"
                        onClick={choose(acceptAnalytics)}
                        className="px-5 py-2.5 text-sm font-semibold bg-weyb-yellow text-weyb-ink hover:bg-weyb-yellow-dark rounded-sm transition-colors"
                    >
                        {c.accept}
                    </button>
                </div>
            </div>
        </div>
    );
}
